import { AbstractControl } from '@angular/forms';
import {
  FileNameValidator,
  MaxSelectFileValidator,
  MaxSizeFileValidator,
  MinSizeFileValidator,
  RequiredFileValidator,
  UploadFileControl,
} from '@portal/upload-file/data-access';
import { PortalFieldConfig } from '@portal/form/data-access';

export const requiredFileValidator = (control: AbstractControl<UploadFileControl>) => {
  return RequiredFileValidator(control);
};

export const maxSelectFileValidator = (control: AbstractControl<UploadFileControl>, field: PortalFieldConfig) => {
  const maxSelectFile = field.props?.maxLength;
  if (!maxSelectFile) return null;
  return MaxSelectFileValidator(maxSelectFile)(control);
};

export const maxSizeFileValidator = (control: AbstractControl<UploadFileControl>, field: PortalFieldConfig) => {
  const maxSizeFile = field.props?.max;
  if (!maxSizeFile) return null;
  return MaxSizeFileValidator(maxSizeFile)(control);
};

export const minSizeFileValidator = (control: AbstractControl<UploadFileControl>, field: PortalFieldConfig) => {
  const minSizeFile = field.props?.min;
  if (!minSizeFile) return null;
  return MinSizeFileValidator(minSizeFile)(control);
};

export const fileNameValidator = (control: AbstractControl<UploadFileControl>, field: PortalFieldConfig) => {
  if (!control.value || !control.value.size) return null;
  return FileNameValidator(control);
};
